import { bindToggles } from "../Shared/scriptts/rootcomponents/toggle";
import * as htmx from "htmx.org";


document.addEventListener('DOMContentLoaded', evt => {
    bindJobEvents();
});

htmx.on('htmx:afterSwap', () => {
    bindToggles();
});

function bindJobEvents() {
    const showDetails = document.querySelectorAll(`[id^=${"showDetails-"}]`)
    showDetails.forEach(function (button) {
        button.addEventListener("click", function (event) {
            let elem = event?.target as HTMLButtonElement;
            showHideEventDetails(elem);
        });
    });

    const toggleBtn = document.querySelector<HTMLButtonElement>("#toggle-button");
    toggleBtn?.addEventListener("click", event => {
        event.preventDefault();
        let elem = event?.target as HTMLButtonElement;
        toggleEventFilters(elem);
    });

    const viewResultsBtn = document.querySelector<HTMLButtonElement>("#view-results");
    viewResultsBtn?.addEventListener("click", event => {
        event.preventDefault();
        let elem = event?.target as HTMLButtonElement;
        toggleEventFilters(elem);
    });

    const clearAllBtn = document.querySelector<HTMLButtonElement>("#clearAllBtn");
    clearAllBtn?.addEventListener("click", event => {
        const filters: NodeListOf<HTMLInputElement> = document.querySelectorAll('input[type="checkbox"]');
        let elem = event?.target as HTMLButtonElement;
        filters.forEach((filterElem) => {
             filterElem.checked = false;
        });
        
        toggleEventFilters(elem);
    });
}

function showHideShareIcons(elem: HTMLElement) {
    if (elem != null) {
        if (elem.nextElementSibling?.classList.contains("hidden")) {
            elem.nextElementSibling?.classList.remove("hidden");
        } else {
            elem.nextElementSibling?.classList.add("hidden");
        }
    }
}
function showHideEventDetails(elem:HTMLButtonElement) {
    const relatedJobsElem = elem.parentElement?.querySelector<HTMLElement>('[data-name=relatedJobs]');
    const expandCollapseBtn = elem.querySelector<HTMLSpanElement>('span');
    const svgShowElement = elem.querySelector<HTMLElement>(`[id^=${"show-"}]`);
    const svgHideElement = elem.querySelector<HTMLElement>(`[id^=${"hide-"}]`);
    
    if (!relatedJobsElem || expandCollapseBtn === null || svgShowElement === null || svgHideElement === null) {
        return;
    }
    if (relatedJobsElem.hasAttribute("hidden")) {
        relatedJobsElem.removeAttribute("hidden");
        svgHideElement.classList.remove("hidden");
        svgShowElement.classList.add("hidden");
        expandCollapseBtn.innerHTML = "Hide details and jobs";
    }
    else {
        relatedJobsElem.setAttribute("hidden", "true");
        svgShowElement.classList.remove("hidden");
        svgHideElement.classList.add("hidden");
        expandCollapseBtn.innerHTML = "Expand details and jobs";
    }
}

function toggleEventFilters(elem: HTMLButtonElement) {
    const eventSectionElem = document.querySelector<HTMLElement>("#events-section");
    const filtersListElem = document.querySelector<HTMLElement>("#filters-list");
    const filterCloseElem = document.querySelector<HTMLSpanElement>("#close-icon");
    const filterIconElem = document.querySelector<HTMLSpanElement>("#filter-icon");
    const filterResultsElem = document.querySelector<HTMLElement>("#filter-results");    
    const mainElem = document.querySelector<HTMLElement>(".main");

    if (eventSectionElem === null || filtersListElem === null || filterCloseElem === null || filterResultsElem === null ||
        filterIconElem === null || filtersListElem === null || mainElem === null) {
        return;
    }

    if (!filtersListElem.classList.contains("hidden")) {
        eventSectionElem.classList.remove("hidden");
        filtersListElem.classList.add('hidden');
        filterCloseElem.classList.add("hidden");
        filterIconElem.classList.remove("hidden");
        filterResultsElem.classList.add("hidden");
        mainElem.scrollIntoView({behavior: 'smooth', block: 'start' });
    }
    else{
        eventSectionElem.classList.add("hidden");
        filtersListElem.classList.remove('hidden');
        filterCloseElem.classList.remove("hidden");
        filterIconElem.classList.add("hidden");
        filterResultsElem.classList.remove("hidden");
        mainElem.scrollIntoView({behavior: 'smooth', block: 'start' });
    }
}
